import RecommendList from "./RecommendList";
export default RecommendList;